import api from '../../api'
import {normalize} from 'normalizr'
import panel from "../schema/panel_schema"

export const SET_PANEL_LIST = 'SET_PANEL_LIST'

const initialState = {
	panels: {
		objects: {},
		list_ids: []
	}
}

const actions = {

	/**
	 * Метод запрашивает REST данные всех панелей,
	 * доступных пользователю
	 * @param commit
	 */
	update: function ({commit}) {

		console.log('store.panels.update() ')

		return api.panels.getNgsPanels()
			.then(function (response) {
					console.log("store.panels.update() then()")

					const panels_norm = normalize(response.data, [panel])

					const panels = {

						// словарь по pgmtools_ngs_panels.short
						objects: panels_norm.entities.objects,

						// список по pgmtools_ngs_panels.short (видимо, сортрированный)
						list_ids: panels_norm.result,

						// словарь по pgmtools_ngs_panels.id
						ids: Object.assign(
							{},
							...Object.values(panels_norm.entities.objects)
								.map((p) => ({[p.id]: p}))
						),
					}
					commit(SET_PANEL_LIST, panels)
				}

				// здесь возвращаем ничего
			)
			.catch(function (error) {
				// TODO: а если потерялась аутентификация?
				throw error
			})
	}
}

const mutations = {
	[SET_PANEL_LIST](state, panels) {
		state.panels = panels
	}
}

const getters = {
	panel_list: function (state) {
		return state.panels.objects
	},
}

export default {
	namespaced: true,
	state: initialState,
	actions,
	mutations,
	getters,
}